import { useEffect, useContext, useCallback, useState } from 'react';
import { useRouter } from 'next/router';
import { i18nContext } from './context/i18n.context';
import { stepContext } from './context/step.context';
import { loggingContext } from './context/logging.context';
import { UserContext } from './context/user.context';
import { referralContext } from '@/context/referral.context';
import ResultsScreen from './results/ResultsScreen';

const AssessmentComplete = () => {
  const { t, locale } = useContext(i18nContext);
  const { complete: result, assessment, components, api, invitation } = useContext(stepContext);
  const { trackAssessmentFinished } = useContext(loggingContext);
  const { agencyClient } = useContext(UserContext);
  const { returnToPage } = useContext(referralContext);
  const router = useRouter();
  const [redirecting, setRedirecting] = useState(false);

  const results = useCallback(components().results, []);
  const properties = { t, locale, result };
  const customComponent = results({ slug: assessment.slug, props: properties });

  useEffect(() => {
    if (assessment?.id) {
      trackAssessmentFinished({ assessmentId: assessment.id, agencyClient });
    }
  }, [assessment?.id, agencyClient?.id]);

  // Bypass ResultsScreen for intake assessments: call the results API directly
  // to mark UserAssessment as finished and redirect back. The api wrapper in
  // AssessmentPage refreshes the agency client in parallel with getAssessmentResults.
  useEffect(() => {
    const isIntake = router.query?.intake === 'true';
    if (!isIntake) return;

    setRedirecting(true);

    const finalizeAndRedirect = async () => {
      try {
        await api.getAssessmentResults(assessment.id, agencyClient?.id, invitation, true);
      } finally {
        window.location.href = returnToPage || '/';
      }
    };

    finalizeAndRedirect();
  }, []);

  if (redirecting) return null;

  return customComponent || <ResultsScreen {...properties} />;
};

export default AssessmentComplete;
